export const FORM_ROUTES = [
  {
    path: 'job-forms',
    name: 'JobFormList',
    component: () => import('./views/JobFormList.vue'),
  },
  {
    path: 'job-forms/create',
    name: 'CreateJobForm',
    component: () => import('./views/CreateJobForm.vue'),
  },
  {
    path: 'job-forms/:id/edit',
    name: 'EditJobForm',
    component: () => import('./views/EditJobForm.vue'),
  },
]
